import cookie from "react-cookies";
import { message } from "antd";
import { TUserInfo } from "./Interfaces";

const COOKIE_DOMAIN = "";
const COOKIE_ACCESS_TOKEN = "atk";
const COOKIE_REFRESH_TOKEN = "rtk";
const COOKIE_USER_INFO = "user_info";

const setCookie = (name: string, value: string): void =>
  localStorage.setItem(name, value);
const getCookie = (name: string): string => localStorage.getItem(name) || "";
const removeCookie = (name: string): void => localStorage.removeItem(name);

class Helpers {
  getRefreshToken = (): string => getCookie(COOKIE_REFRESH_TOKEN);

  storeRefreshToken = (refreshToken: string): void =>
    setCookie(COOKIE_REFRESH_TOKEN, refreshToken);

  getAccessToken = (): string => getCookie(COOKIE_ACCESS_TOKEN);

  storeAccessToken = (accessToken: string): void =>
    setCookie(COOKIE_ACCESS_TOKEN, accessToken);

  clearToken = (): void => {
    removeCookie(COOKIE_REFRESH_TOKEN);
    removeCookie(COOKIE_ACCESS_TOKEN);
  };

  getUserInfo = () => {
    const userInfo: any = getCookie(COOKIE_USER_INFO);
    return userInfo != "" ? JSON.parse(userInfo) : null;
  };

  storeUserInfo = (userInfo: object): void => {
    const userInfoString = JSON.stringify(userInfo);
    setCookie(COOKIE_USER_INFO, userInfoString);
  };

  removeUserInfo = (): void => {
    removeCookie(COOKIE_USER_INFO);
  };

  isLoggedIn = (): boolean => {
    return this.getAccessToken() == "" || this.getAccessToken() == undefined ? false : true;
  };

  isAdmin = (): boolean => {
    return this.getUserInfo() && this.getUserInfo().role_id == 2;
  };

  isRecruiter = (): boolean => {
    return this.getUserInfo() && this.getUserInfo().default_view == "Recruiter";
  };

  isTalent = (): boolean => {
    return this.getUserInfo() && this.getUserInfo().default_view == "Talent";
  };

  isEmployer = (): boolean => {
    return this.getUserInfo() && this.getUserInfo().default_view == "Employer";
  };

  getLoginRoute = (): string => {
    var router = "";
    switch (this.getUserInfo().default_view) {
      case "Talent":
        router = "/talent/panel";
        break;
      case "Recruiter":
        router = "/recruiter/panel";
        break;
      case "Employer":
        router = "/";
        break;
    }
    return router;
  };

  notification = {
    success: (content: string) => {
      message.open({
        type: "success",
        content: content,
      });
    },
    error: (content: string) => {
      message.open({
        type: "error",
        content: content,
      });
    },
    warning: (content: string) => {
      message.open({
        type: "warning",
        content: content,
      });
    },
  };

  businessPayload = {
    script: (script_id: number, content: any) => {
      return {
        script_id: script_id,
        backend_instance_id: 1,
        content: content,
      };
    },
  };

  redirect = (url: string) => {
    window.location.href = url
  }

  formattedDate = (dateString: string): any => {
    const date = new Date(dateString);
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();

    return `${month}/${year}`;
  };

  formattedUTC = (dateString: string | Date, isYear: boolean = false): string => {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear());

    const formattedDate = isYear ? `${year}-${month}-${day}` : `${day}-${month}`;

    return formattedDate
  };

  unformattedUTC = (dateString: string) => {
    const date = new Date(dateString);
    return date;
  };

  calculateDuration = (startDate: Date, endDate: Date) => {
    const d1: any = new Date(startDate);
    const d2: any = new Date(endDate);

    const timeDifference = d2 - d1;
    const daysDifference = timeDifference / (1000 * 3600 * 24);

    return daysDifference;
  };

  validateDate = (dateString: string) => {
    const regex = /^(0[1-9]|1[0-2])\/\d{4}$/;
    if (!regex.test(dateString)) {
      return false;
    }
    const [month, year] = dateString.split("/").map(Number);
    if (year < 1900 || year > 2030) {
      return false;
    }

    return true;
  };

}

const instance = new Helpers();
export default instance;
